import { ReactNode } from 'react';
import Button from '../ui/Button';
import { useNavigate } from 'react-router-dom';

interface ICardLayout {
  children: ReactNode;
  cardStyle?: string;
  isGrid?: boolean;
  isViewAll?: boolean;
  redirect?: string;
  heading?: string;
}
const CardLayout = ({
  children,
  cardStyle,
  isGrid = false,
  isViewAll = false,
  redirect,
  heading,
}: ICardLayout) => {
  const navigate = useNavigate();
  return (
    <div className={isGrid ? '' : `card ${cardStyle}`}>
      {heading && (
        <div className="p-3 pb-0 d-flex justify-content-between align-items-center">
          <h4 className="title">{heading}</h4>
          {isViewAll && redirect && (
            <Button
              className="btn text-primary fw-semibold"
              onClick={() => navigate(redirect)}
            >
              View All
            </Button>
          )}
        </div>
      )}
      <div className={isGrid ? '' : 'card-body'}>{children}</div>
    </div>
  );
};
export default CardLayout;
